export const docDate = 'February 3, 2025'; // for documents
